import { render, staticRenderFns } from "./TotalCost.vue?vue&type=template&id=0d596de2"
import script from "./TotalCost.vue?vue&type=script&lang=ts"
export * from "./TotalCost.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports